"use client";

import { createContext, useContext, type ReactNode } from "react";

/**
 * Default backend URL, read from the server's `API_URL` at request time so it
 * is not frozen into the build.
 */
const ApiUrlContext = createContext<string>("");

export function ApiUrlProvider({
  apiUrl,
  children,
}: {
  apiUrl: string;
  children: ReactNode;
}) {
  return (
    <ApiUrlContext.Provider value={apiUrl}>{children}</ApiUrlContext.Provider>
  );
}

export function useDefaultApiUrl(): string {
  return useContext(ApiUrlContext);
}
